export default "__VITE_ASSET__fe8cd923__"